import React, {useState} from "react";
import "./01-forms.css"

const CreationPopup = ({ openPatientForm, openOperationForm }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (

    <div className="sticky-button-container">
      <button className="sticky-button" onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? "X" : "+"} {/** Ssh I know this isn't a X, but it looks aesthetic. no it doesn't...*/}
      </button>      



      {/* Expanded Buttons (basically the ispopupvisible **** but now it's just with this instead) */}
      {isExpanded && (
        <div className="expanded-buttons show">
          <button className="create-patient-button" onClick={openPatientForm}>
            Create New Patient
          </button>
          <button className="create-operation-button" onClick={openOperationForm}>
            Create New Operation
          </button>
        </div>
      )}


    </div>
  );
};

export default CreationPopup;
